export default {
    agentAssist: {
        callerConverseChannel: "AgentAssistCaller",
        errorReportingEventName: "AgentAssistError",
        errorReportingEventValue: "MaxAllowedErrorsReached",
        maxErrorCountAllowed: 2,
        settings: {},
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/agent-assist.ts